module.exports = __webpack_public_path__ + "media/images/case_studies/moet_hennessy/trends-f92c1ea872c416f126ff90ff8d706ce9.svg";